<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-plat__platinfoca}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.caName" placeholder="企业名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.taxCode" placeholder="信用代码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('plat:platinfoca:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('plat:platinfoca:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{(page - 1) * limit + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="caName" label="企业名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="taxCode" label="社会信用代码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankName" label="开户行" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bankAccount" label="开户账号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="address" label="注册地址" header-align="center" align="center"></el-table-column>
        <el-table-column prop="contacts" label="联系人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="phone" label="注册电话" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isEnable" label="是否启用" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isEnable === 0" size="small" type="danger">禁用</el-tag>
            <el-tag v-else size="small" type="success">启用</el-tag>
          </template>

        </el-table-column>
        <!--<el-table-column prop="status" label="审核状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ $getDictLabel("taskStatus", scope.row.status) }}
          </template>
        </el-table-column>-->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('plat:platinfoca:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">查看详情</el-button>
            <el-button v-if="$hasPermission('plat:platinfoca:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('plat:platinfoca:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
	  background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platinfoca-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/info/ca/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/info/ca',
        deleteIsBatch: true
      },
      dataForm: {
        id: '',
        caName: '',
        taxCode: ''

      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
